const page_schema = {
	"tiers": [
		{
			"name": "Applications",
			"type": "checkbox",
			"id": "applications_dropdown",
			"class_name": "tags",
			"child_name": "application",
			"options": [
				{
					"name": "Bacteria",
					"id": "bacteria"
				},
				{
					"name": "Fungi",
					"id": "fungi"
				},
				{
					"name": "Archaea",
					"id": "archaea"
				},
				{
					"name": "Feces",
					"id": "feces"
				},
				{
					"name": "Soil",
					"id": "soil"
				},
				{
					"name": "Saliva",
					"id": "saliva"
				},
				{
					"name": "Skin",
					"id": "skin"
				},
				{
					"name": "Vaginal",
					"id": "vaginal"
				},
				{
					"name": "Tissue",
					"id": "tissue"
				},
				{
					"name": "Water",
					"id": "water"
				},
				{
					"name": "Plants",
					"id": "plants"
				},
				{
					"name": "Insects",
					"id": "insects"
				},
				{
					"name": "Urine",
					"id": "urine"
				},
				{
					"name": "Blood",
					"id": "blood"
				},
			]
		},
		// {
		// 	"name": "Workflow Stage",
		// 	"type": "checkbox",
		// 	"id": "workflow-stages",
		// 	"class_name": "tags",
		// 	"child_name": "workflow-stage",
		// 	"options": [
		// 		{
		// 			"name": "Standards",
		// 			"id": "standards"
		// 		},
		// 		{
		// 			"name": "Extraction",
		// 			"id": "extraction"
		// 		},
		// 		{
		// 			"name": "Library Prep",
		// 			"id": "library-prep"
		// 		},
		// 	]
		// },
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Low Input",
					"id": "low-input"
				},
				{
					"name": "Long Read",
					"id": "long-read"
				},
				{
					"name": "Extraction Control",
					"id": "extraction-control"
				},
				{
					"name": "Library Prep Control",
					"id": "library-prep-control"
				},
				{
					"name": "Absolute Quantification",
					"id": "absolute-quantification"
				},
				{
					"name": "Limit of Detection",
					"id": "limit-of-detection"
				},
				{
					"name": "16S V1-V2",
					"id": "16s-v1-v2"
				},
				{
					"name": "16S V1-V3",
					"id": "16s-v1-v3"
				},
				{
					"name": "16S V3-V4",
					"id": "16s-v3-v4"
				},
				{
					"name": "16S V4",
					"id": "16s-v4"
				},
				{
					"name": "ITS2",
					"id": "its2"
				},
				{
					"name": "DNA",
					"id": "dna"
				},
				{
					"name": "RNA",
					"id": "rna"
				},
				{
					"name": "CE-IVD",
					"id": "ce-ivd"
				},
				{
					"name": "High-Throughput",
					"id": "high-throughput"
				},
				{
					"name": "High Molecular Weight DNA",
					"id": "high-molecular-weight-dna"
				},
				{
					"name": "Host Depletion",
					"id": "host-depletion"
				},
				{
					"name": "Low Bioburden for Metagenomics",
					"id": "low-bioburden-for-metagenomics"
				},
				{
					"name": "16S Full-Length",
					"id": "16s-full-length"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "Intact Cells",
					"id": "intact-cells"
				},
				{
					"name": "Native Diversity",
					"id": "native-diversity"
				},
				{
					"name": "Mock Community",
					"id": "mock-community"
				},
				{
					"name": "Spike-in Control",
					"id": "spike-in-control"
				},
				{
					"name": "Column Purification",
					"id": "column-purification"
				},
				{
					"name": "Magbead Purification",
					"id": "magbead-purification"
				},
				{
					"name": "96-Well Spin Plate",
					"id": "96-well-spin-plate"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"ZymoBIOMICS Microbial Community Standard": {
			"title": "ZymoBIOMICS Microbial Community Standard",
			"catalogNumbers": "D6300",
			"description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS Microbial Community Standard is designed to assess bias and errors in the extraction methods of a microbiomics workflow. The Microbial Community Standard mimics a mixed microbial community of well-defined composition, containing three easy-to-lyse Gram-negative bacteria, five tough-to-lyse Gram-positive bacteria, and two tough-to-lyse yeasts. Acting as a defined input from the beginning, the Microbial Community Standard can guide construction and optimization of entire workflows and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA:Listeria monocytogenes- 12%,Pseudomonas aeruginosa- 12%,Bacillus subtilis- 12%,Escherichia coli- 12%,Salmonella enterica- 12%,Lactobacillus fermentum- 12%,Enterococcus faecalis- 12%,Staphylococcus aureus- 12%,Saccharomyces cerevisiae- 2%, andCryptococcus neoformans- 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6300_ZymoBIOMICS-Microbial-Community-Standard.jpg?v=1628532362&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-microbial-community-standard",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"extraction-control",
				"intact-cells",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community DNA Standard": {
			"title": "ZymoBIOMICS Microbial Community DNA Standard",
			"catalogNumbers": "D6305, D6306",
			"description": "One of the major challenges in the emerging field of microbiomics is the bias and errors introduced in the complex workflows. Besides nucleic acid purification, bias also arises from sequencing library preparation and subsequent processes. The ZymoBIOMICS Microbial Community DNA Standard is designed to assess bias, errors and other artifacts after the step of nucleic acid purification. This DNA standard is created by pooling DNA extracted from pure cultures. It has an accurately defined composition, negligible impurities (0.01%), and contains genomes of a wide range of GC content (15% - 85%). This DNA standard is designed to have the same microbial composition with the cellular version, the ZymoBIOMICS Microbial Community Standard, so that they can be more powerful when working in tandem. Theoretical Composition Based on Genomic DNA:Listeria monocytogenes- 12%,Pseudomonas aeruginosa- 12%,Bacillus subtilis- 12%,Escherichia coli- 12%,Salmonella enterica- 12%,Lactobacillus fermentum- 12%,Enterococcus faecalis- 12%,Staphylococcus aureus- 12%,Saccharomyces cerevisiae- 2%, andCryptococcus neoformans- 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6305_ZymoBIOMICS-Microbial-Community-Standard.jpg?v=1628532363&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-microbial-community-dna-standard",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"library-prep-control",
				"dna",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community Standard II (Log Distribution)": {
			"title": "ZymoBIOMICS Microbial Community Standard II (Log Distribution)",
			"catalogNumbers": "D6310",
			"description": "ZymoBIOMICS Microbial Community Standard II (Log Distribution) is a mock microbial community consisting of eight bacterial and two fungal strains. This microbial standard can be used to assess the performance of microbiomics workflows and can also be used as a positive control for routine sequencing. Cells of the ten microbes were mixed in a log-distributed abundance, which allows the user to easily assess the detection limit of their microbiomics workflow. 75 µl of the standard contains about ~100 cells ofStaphylococcus aureus, the organism of lowest abundance. If needed, the standard can be spiked into a sample matrix (e.g. soil and blood) to mimic real samples of interest. Theoretical Composition Based on Genomic DNA:Listeria monocytogenes- 89.1%,Pseudomonas aeruginosa- 8.9%,Bacillus subtilis- 0.89%,Saccharomyces cerevisiae- 0.89%,Escherichia coli- 0.089%,Salmonella enterica- 0.089%,Lactobacillus fermentum- 0.0089%,Enterococcus faecalis- 0.00089%,Cryptococcus neoformans- 0.00089%, andStaphylococcus aureus- 0.000089%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-standard-ii-log-distribution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6310_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_750-ul.jpg?v=1628532379&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-microbial-community-standard-ii-log-distribution",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"long-read",
				"extraction-control",
				"limit-of-detection",
				"intact-cells",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution)": {
			"title": "ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution)",
			"catalogNumbers": "D6311",
			"description": "ZymoBIOMICS Microbial Community DNA Standard II (Log Distribution) is a mixture of genomic DNA of eight bacterial and two fungal strains. The microbial standard is accurately characterized and contains negligible impurity (< 0.01%). It was constructed by pooling DNA extracted from pure cultures of the ten microbial strains. The DNA from each pure culture was quantified before pooling. After mixing, the microbial composition was confirmed using NGS-based sequencing. This microbial standard can be used to assess the performance of microbiomics workflows and can also be used as a positive control for the routine QC purpose. Theoretical Composition Based on Genomic DNA:Listeria monocytogenes- 89.1%,Pseudomonas aeruginosa- 8.9%,Bacillus subtilis- 0.89%,Saccharomyces cerevisiae- 0.89%,Escherichia coli- 0.089%,Salmonella enterica- 0.089%,Lactobacillus fermentum- 0.0089%,Enterococcus faecalis- 0.00089%,Cryptococcus neoformans- 0.00089%, andStaphylococcus aureus- 0.000089%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-microbial-community-dna-standard-ii-log-distribution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6311_ZymoBIOMICS-Microbial-Community-Standard-II-Log-Distribution_20-ul.jpg?v=1628532418&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-microbial-community-dna-standard-ii-log-distribution",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"library-prep-control",
				"limit-of-detection",
				"dna",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Spike-in Control I (High Microbial Load)": {
			"title": "ZymoBIOMICS Spike-in Control I (High Microbial Load)",
			"catalogNumbers": "D6320, D6320-10",
			"description": "ZymoBIOMICS™ Spike-in Control I (High Microbial Load) consists of equal cell numbers of two bacteria strains,Imtechella halotoleransandAllobacillus halotolerans.When spiked into an unknown sample, this product will serve as anin situpositive control for DNA-sequencing-based (e.g. NGS-based) microbiome measurements. These two bacteria,Imtechella halotolerans(Gram-negative) andAllobacillus halotolerans(Gram-positive) represent different cell recalcitrance and can expose potential bias during DNA extraction. Moreover, with accurately quantified cell numbers, this standard enables absolute cell number quantification in microbiome measurements.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-spike-in-control-i-high-microbial-load",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6320.png?v=1628532418&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-spike-in-control-i-high-microbial-load",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"extraction-control",
				"absolute-quantification",
				"intact-cells",
				"mock-community",
				"spike-in-control",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Spike-in Control II (Low Microbial Load)": {
			"title": "ZymoBIOMICS Spike-in Control II (Low Microbial Load)",
			"catalogNumbers": "D6321, D6321-10",
			"description": "ZymoBIOMICS Spike-in Control II (Low Microbial Load) consists of three bacteria strains,Truepera radiovictrix,Imtechella halotoleransandAllobacillus halotolerans. When spiked into a microbial sample, this product will serve as anin situpositive control for DNA-sequencing-based microbiome measurements. Of the three chosen bacteria,Imtechella halotoleransis Gram-negative andAllobacillus halotoleransis Gram-positive.Truepera radiovictrixis resistant to lysozyme lysis and has very high GC content. They represent different challenges in NGS-based analysis. Moreover, with accurately quantified cell number and a log abundance distribution, this standard enables absolute cell number quantification in cases such as pathogen load detection.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-spike-in-control-ii-low-microbial-load",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6321-zymobiomics_spike-in_control_ii.png?v=1628532418&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-spike-in-control-ii-low-microbial-load",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"low-input",
				"long-read",
				"extraction-control",
				"absolute-quantification",
				"limit-of-detection",
				"intact-cells",
				"mock-community",
				"spike-in-control",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS HMW DNA Standard": {
			"title": "ZymoBIOMICS HMW DNA Standard",
			"catalogNumbers": "D6322",
			"description": "ZymoBIOMICS HMW DNA Standard is a mixture of high molecular weight genomic DNA isolated from pure cultures of seven bacterial and one fungal strains. It has an accurately defined composition, negligible impurities (<0.01%) and contains genomes of a wide range of GC content (15%-85%). This can be used to assess and benchmark the performance of long read/3rd generation sequencing for microbiomics and metagenomics analysis and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA:Pseudomonas aeruginosa- 14%,Escherichia coli- 14%,Salmonella enterica- 14%,Enterococcus faecalis- 14%,Staphylococcus aureus- 14%,Listeria monocytogenes- 14%,Bacillus subtilis- 14%,Saccharomyces cerevisiae- 2%.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-hmw-dna-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6322-zymobiomics-hmw-dna-standard.png?v=1628532418&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-hmw-dna-standard",
			"tags": [
				"bacteria",
				"fungi",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"library-prep-control",
				"dna",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Fecal Reference with TruMatrix™ Technology": {
			"title": "ZymoBIOMICS Fecal Reference with TruMatrix™ Technology",
			"catalogNumbers": "D6323",
			"description": "The ZymoBIOMICS Fecal Reference with TruMatrix™ Technology is a microbial reference material composed of stool from healthy donors for quality control, process validation, assay development, and proficiency testing. The fecal reference was homogenized in one large batch to produce consistency in every vial, eliminating typical lot-to-lot variability. With over 2 million preps available, this reference is intended to be used as a control for workflow performance, as well as comparing workflow consistency across replicates, studies, and laboratories. To facilitate methods comparison, a platform is in development to enable users to compare characterization data against applied methodology. For more information about the platform, please contactmicrobiomics@zymoresearch.com.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-fecal-reference-with-trumatrix-technology",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6323_ZymoBIOMICS-Fecal-Reference-with-TruMatrix.jpg?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-fecal-reference-with-trumatrix-technology",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"long-read",
				"extraction-control",
				"intact-cells",
				"native-diversity",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS Gut Microbiome Standard": {
			"title": "ZymoBIOMICS Gut Microbiome Standard",
			"catalogNumbers": "D6331",
			"description": "The ZymoBIOMICS Gut Microbiome Standard is an accurately quantified microbial community mimicking the human gut microbiome. The challenges it presents to microbiomics profiling allows researchers to validate protocols and fine-tune them for gut microbiome research and act as a positive control for sample processing.",
			"handle": "/collections/zymobiomics-microbial-community-standards/products/zymobiomics-gut-microbiome-standard",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6331_zymobiomics_gut_microbiome_standard-750ul.png?v=1628532419&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-gut-microbiome-standard",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"long-read",
				"extraction-control",
				"limit-of-detection",
				"intact-cells",
				"mock-community",
				"standards",
			],
			filters: []
		},
		"ZymoBIOMICS DNA Miniprep Kit": {
			"title": "ZymoBIOMICS DNA Miniprep Kit",
			"catalogNumbers": "D4300, D4300T, D4304",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae) making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-dna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4300_ZymoBIOMICS-DNA-Miniprep-Kit.jpg?v=1628532366&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-dna-miniprep-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"tissue",
				"water",
				"dna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS DNA Microprep Kit": {
			"title": "ZymoBIOMICS DNA Microprep Kit",
			"catalogNumbers": "D4301, D4305",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae) making it ideal for microbial community profiling. Uniform mechanical lysis of tough microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-dna-microprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4301_ZymoBIOMICS-DNA-Microprep-Kit.jpg?v=1628532363&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-dna-microprep-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"saliva",
				"skin",
				"vaginal",
				"dna",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS 96 Magbead DNA Kit": {
			"title": "ZymoBIOMICS 96 Magbead DNA Kit",
			"catalogNumbers": "D4302, D4302-E, D4306, D4306-E, D4308, D4308-E",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.jpg?v=1668718447&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-96-magbead-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"high-throughput",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS 96 MagBead DNA Kit – Dx": {
			"title": "ZymoBIOMICS 96 MagBead DNA Kit – Dx",
			"catalogNumbers": "D4302-E, D4306-E, D4308-E",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb. For automation scripts and support, email automation@zymoresearch.com",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-magbead-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4306_ZymoBIOMICS-96-MagBead-DNA-Kit_No-lysis-matrix.jpg?v=1668718447&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-96-magbead-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"dna",
				"ce-ivd",
				"high-throughput",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS 96 DNA Kit": {
			"title": "ZymoBIOMICS 96 DNA Kit",
			"catalogNumbers": "D4303, D4307, D4309",
			"description": "The ZymoBIOMICS DNA Kits are microbial DNA purification kits designed for purifying DNA from a variety of sample inputs that is immediately ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae), making it ideal for microbial community profiling. Uniform mechanical lysis of all microbes is achieved by bead beating with the innovative ultra-high density BashingBeads. This kit is equipped with our OneStep PCR Inhibitor removal technology, enabling PCR amplification from DNA derived from inhibitor-rich environmental samples. Purified DNA is ideal for all downstream applications including PCR, arrays, 16S rRNA gene sequencing, and shotgun sequencing. DNA Size is 15-20 kb.",
			"handle": "/collections/zymobiomics-dna-kits/products/zymobiomics-96-dna-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4303_ZymoBIOMICS-96-DNA-Kit_Lysis-rack.png?v=1628532361&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-96-dna-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"tissue",
				"water",
				"dna",
				"high-throughput",
				"low-input",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"96-well-spin-plate",
				"extraction",
			],
			filters: []
		},
		"HostZERO Microbial DNA Kit": {
			"title": "HostZERO Microbial DNA Kit",
			"catalogNumbers": "D4310",
			"description": "The HostZERO Microbial DNA Kit is designed to overcome the challenge of contaminating host nucleic acids in microbial samples. This kit uses a novel method to reduce the amount of contaminating host DNA by selectively lysing the eukaryotic cells and degrading this DNA prior to total DNA purification. Paired with Zymo Research's non-biased purification technology, the HostZERO Microbial DNA Kit allows for the exclusive capture of DNA from living microbial cells in a biological sample. This new technology is able to reduce the presence of human DNA in a saliva sample from 65% (untreated sample) to less than 1% (treated sample). Concurrently, the depletion process utilizes the ZymoBIOMICS non-biased DNA isolation technology for accurate data representation. Finally, the HostZERO Microbial DNA Kit recovers the highest amount of bacterial DNA as compared to other methods. By removing the presence of host DNA and reducing bias in purification, the HostZERO Microbial DNA Kit produces the highest-quality data for microbial samples.",
			"handle": "/products/hostzero-microbial-dna-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D4310-A_HostZERO-Microbial-DNA-Kit.jpg?v=1628532417&width=600",
			"generalIndex": "998",
			"id": "hostzero-microbial-dna-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"urine",
				"dna",
				"low-input",
				"host-depletion",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS RNA Miniprep Kit": {
			"title": "ZymoBIOMICS RNA Miniprep Kit",
			"catalogNumbers": "R2001",
			"description": "The ZymoBIOMICS RNA Miniprep Kit is designed for purifying RNA from a wide array of sample inputs that is ready for microbiome or metagenome analyses. The ZymoBIOMICS lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae). The procedure uses Zymo-Spin Column technology that results in high-quality total RNA (including small RNAs 17-200 nt) that is free of PCR inhibitors and is ready for RT-PCR, hybridization, sequencing, etc. DNase I included.",
			"handle": "/products/zymobiomics-rna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2001_ZymoBIOMICS-RNA-Miniprep-Kit.jpg?v=1628532353&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-rna-miniprep-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"tissue",
				"water",
				"plants",
				"rna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS DNA/RNA Miniprep Kit": {
			"title": "ZymoBIOMICS DNA/RNA Miniprep Kit",
			"catalogNumbers": "R2002",
			"description": "The ZymoBIOMICS DNA/RNA Miniprep Kit is designed for purifying DNA and RNA from a wide array of sample inputs (e.g. feces, soil, plant, water, and biofilms) that is ready for microbiome or metagenome analyses. The ZymoBIOMICS innovative lysis system eliminates bias associated with unequal lysis efficiencies of different organisms (e.g. Gram-negative/positive bacteria, fungus, protozoans, and algae). The provided DNA/RNA Shield preserves nucleic acids at ambient temperatures, providing an unbiased molecular snapshot of the sample. The procedure uses Zymo-Spin Column technology that results in high-quality DNA and total RNA (including small RNAs 17-200 nt) that is free of PCR inhibitors (e.g. polyphenols, humic acids, and fulvic acids). Ready for RT-PCR, arrays, sequencing, etc.",
			"handle": "/products/zymobiomics-dna-rna-miniprep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/R2002_ZymoBIOMICS-DNA-RNA-Miniprep-Kit.jpg?v=1628532356&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-dna-rna-miniprep-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"tissue",
				"water",
				"plants",
				"dna",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"column-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS MagBead DNA/RNA": {
			"title": "ZymoBIOMICS MagBead DNA/RNA Kit",
			"catalogNumbers": "R2135, R2136",
			"description": "The ZymoBIOMICS MagBead DNA/RNA kit provides a high-throughput, magnetic bead-based purification of both high-quality DNA and total RNA (including small/microRNAs) from the same starting sample. The provided DNA/RNA Shield inactivates infectious agents and is ideal for sample storage at ambient temperatures. The extraction method utilizes magnetic beads for DNA/RNA extraction without the use of phenol and is eluted into ≥50 µl of ZymoBIOMICS DNase/RNase-Free Water. DNA/RNA is ready for any downstream application including Next-Gen Sequencing, RT-qPCR, etc.",
			"handle": "/products/zymobiomics-magbead-dna-rna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2135_zymobiomics_96_magbead_dna_rna_kit.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-magbead-dna-rna",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"dna",
				"high-throughput",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"extraction",
			],
			filters: []
		},
		"ZymoBIOMICS MagBead RNA": {
			"title": "ZymoBIOMICS MagBead RNA",
			"catalogNumbers": "R2137, R2138",
			"description": "The ZymoBIOMICS MagBead RNA kit provides a high-throughput, magnetic beadbased purification of total RNA (including small/microRNAs) from any sample source (e.g., microbes including gram positive/negative bacteria, fungi, protozoans, viruses, fecal, soil, plant, water, biofilms, swabs, saliva, body fluids and etc.). The provided DNA/RNA Shield inactivates infectious agents and is ideal for sample storage at ambient temperatures. Total RNA is eluted into ≥50 µl of ZymoBIOMICS DNase/RNase-Free Water and is ready for any downstream application including Next-Gen Sequencing, RT-qPCR, etc. For automation scripts and support, emailautomation@zymoresearch.com",
			"handle": "/products/zymobiomics-magbead-rna",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/r2137_zymobiomics-magbead-rna-kit.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "zymobiomics-magbead-rna",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"rna",
				"high-throughput",
				"high-molecular-weight-dna",
				"low-bioburden-for-metagenomics",
				"magbead-purification",
				"extraction",
			],
			filters: []
		},
		"Quick-16S NGS Library Prep Kit": {
			"title": "<i>Quick</i>-16S NGS Library Prep Kit",
			"catalogNumbers": "D6400",
			"description": "Microbial composition profiling techniques powered by Next-Generation sequencing are becoming routine in microbiomics and metagenomics studies. However, these analytical techniques can suffer from significant bias from collection to analysis. The ZymoBIOMICS Microbial Community Standard is designed to assess bias and errors in the extraction methods of a microbiomics workflow. The Microbial Community Standard mimics a mixed microbial community of well-defined composition, containing three easy-to-lyse Gram-negative bacteria, five tough-to-lyse Gram-positive bacteria, and two tough-to-lyse yeasts. Acting as a defined input from the beginning, the Microbial Community Standard can guide construction and optimization of entire workflows and can also be used as a routine quality control. Theoretical Composition Based on Genomic DNA:Listeria monocytogenes- 12%,Pseudomonas aeruginosa- 12%,Bacillus subtilis- 12%,Escherichia coli- 12%,Salmonella enterica- 12%,Lactobacillus fermentum- 12%,Enterococcus faecalis- 12%,Staphylococcus aureus- 12%,Saccharomyces cerevisiae- 2%, andCryptococcus neoformans- 2%.",
			"handle": "/products/quick-16s-ngs-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6400_Quick-16S_20NGS_20Library_20Prep_20Kit.png?v=1628532355&width=600",
			"generalIndex": "998",
			"id": "quick-16s-ngs-library-prep-kit",
			"tags": [
				"16s-v1-v2",
				"16s-v3-v4",
				"library-prep",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V4)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V4)",
			"catalogNumbers": "D6430-PS1, D6430-PS2, D6430-PS3, D6430-PS4, D6432",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V4) is the fastest and simplest NGS library prep targeting the V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a premixed amplification plate and a single qPCR/PCR for combined targeted amplification and barcode addition. Pooling by equal volume and a single clean-up of the final library, rather than massive AMPure<sup>®</sup>bead-based clean-ups, simplifies the library prep process. Additional library quantification analysis such as TapeStation<sup>®</sup>analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v4",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D6430_Quick-16S-Plus-NGS-Library-Prep-Kit-_V4.jpg?v=1658345576&width=600",
			"generalIndex": "998",
			"id": "quick-16s-plus-ngs-library-prep-kit-v4",
			"tags": [
				"16s-v4",
				"library-prep",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V3-V4)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V3-V4)",
			"catalogNumbers": "D6421-PS1, D6421-PS2, D6421-PS3, D6421-PS4, D6421-PS5, D6421-PS6, D6421-PS7, D6421-PS8",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V3-V4) is the fastest and simplest NGS library prep targeting the V3-V4 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup>bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup>analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/d6420-quick_16s_plus_ngs_library_prep_kit_5760x5760_b92f8884-354d-48bf-9660-e41bd948cd3f.jpg?v=1690506528&width=600",
			"generalIndex": "998",
			"id": "quick-16s-plus-ngs-library-prep-kit",
			"tags": [
				"16s-v3-v4",
				"library-prep",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V2)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V2)",
			"catalogNumbers": "D6434-PS1",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V1-V2) is the fastest and simplest NGS library prep targeting the V1-V2 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup>bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup>analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v2",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6434Quick-16SNGSLibraryPrepKit_V1-V2.jpg?v=1701709549",
			"generalIndex": "998",
			"id": "quick-16s-plus-ngs-library-prep-kit-v1-v2",
			"tags": [
				"16s-v1-v2",
				"library-prep",
			],
			filters: []
		},
		"Quick-16S Plus NGS Library Prep Kit (V1-V3)": {
			"title": "<i>Quick</i>-16S Plus NGS Library Prep Kit (V1-V3)",
			"catalogNumbers": "D6440-PS1, D6440-PS2, D6440-PS3, D6440-PS4",
			"description": "The Quick-16S Plus NGS Library Prep Kit (V1-V3) is the fastest and simplest NGS library prep targeting the V1-V3 region of the 16S rRNA gene for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup>bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup>analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-16s-plus-ngs-library-prep-kit-v1-v3",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/files/D6440Quick-16SNGSLibraryPrepKit_V1-V3.jpg?v=1701709564",
			"generalIndex": "998",
			"id": "quick-16s-plus-ngs-library-prep-kit-v1-v3",
			"tags": [
				"16s-v1-v3",
				"library-prep",
			],
			filters: []
		},
		"Quick-ITS Plus NGS Library Prep Kit (UDI)": {
			"title": "<i>Quick</i>-ITS Plus NGS Library Prep Kit (UDI)",
			"catalogNumbers": "D6425-PS1, D6425-PS2, D6425-PS3, D6425-PS4",
			"description": "Quick-ITS Plus NGS Library Prep Kit (UDI) is the fastest and simplest NGS library prep targeting the ITS region for high-throughput sequencing. The automation-friendly protocol utilizes a single qPCR/PCR for combined targeted amplification and barcode addition using specially designed primers. After pooling by equal volume, a single clean-up of the final library is performed, rather than massive AMPure<sup>®</sup> bead-based clean-ups. Additional library quantification analysis such as TapeStation<sup>®</sup> analysis or gel electrophoresis are not necessary. With these features, the workflow dramatically reduces the hands-on time of library preparation to only 30 minutes.",
			"handle": "/products/quick-its-plus-ngs-library-prep-kit-udi",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d6424-quick_its_plus_ngs_library_prep_kit.jpg?v=1628532419&width=600",
			"generalIndex": "998",
			"id": "quick-its-plus-ngs-library-prep-kit",
			"tags": [
				"its2",
				"library-prep",
			],
			filters: []
		},
		"Quick-16S/ITS NGS Library Prep Kit Sampler": {
			"title": "<i>Quick</i>-16S/ITS NGS Library Prep Kit Sampler",
			"catalogNumbers": "D6499",
			"description": "The Quick-16S/ITS™ NGS Library Prep Sampler provides 8 reactions from each of our Quick-16S/ITS™ Plus library prep kits as well as our Quick -16S™ Full-Length Library Prep Kit. Sample the Microbiomics library prep kit portfolio in one convenient format.",
			"handle": "/products/quick-16s-its-ngs-library-prep-sampler",
			"navigation_image": "https://files.zymoresearch.com/images/filter_page/microbiome/D6499.webp",
			"generalIndex": "998",
			"id": "quick-16s-its-ngs-library-prep-sampler",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"16s-v1-v2",
				"16s-v1-v3",
				"16s-v3-v4",
				"16s-v4",
				"its2"
			],
			filters: []
		},
		"Quick-16S Full-Length Library Prep Kit": {
			"title": "<i>Quick</i>-16S Full-Length Library Prep Kit",
			"catalogNumbers": "D6450-PS1, D6450-PS2, D6450-PS3, D6450-PS4",
			"description": "The <i>Quick</i>-16S Full-Length Library Prep Kit delivers pooled and purified libraries ready for downstream sequencing on PacBio & Oxford Nanopore sequencing platforms in as little as 30 minutes of hands-on time.",
			"handle": "/products/quick-16s-full-length-library-prep-kit",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/files/D6450-BQuick-16SFullLengthLibraryKit_600x.webp",
			"generalIndex": "998",
			"id": "quick-16s-full-length-library-prep-kit",
			"tags": [
				"bacteria",
				"fungi",
				"archaea",
				"feces",
				"soil",
				"saliva",
				"skin",
				"vaginal",
				"tissue",
				"water",
				"plants",
				"insects",
				"urine",
				"blood",
				"long-read",
				"16s-full-length",
			],
			filters: []
		},
	}
}